import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableHighlight,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, ToastAndroid
} from "react-native";

const {width: SCREEN_WIDTH} = Dimensions.get("window");


import moment from "moment-jalaali";
//import fa from "moment/src/locale/fa";


moment.locale("fa");
moment.loadPersian()
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors from "../../../../tools/Colors";
import HMTextInput from "../../../../customviews/HMTextInput";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import * as NavigationService from "../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {Tools} from "../../../../tools/Tools";
import axios from "axios";
import {moderateScale, verticalScale} from "../../../../tools/Scaling";

let container = null;
import DatePicker from '../../../../customviews/PersianDatePicker'
import store from "../../../../redux/store";
//import SpeechAndroid from "react-native-android-voice-persian";
import {typeExport} from "../../../../redux/store/type";
import PathFile from "../../../../assets/PathFile";
import HMAlert from "../../../../customviews/HMAlert";
import connect from "react-redux/es/connect/connect";

class AdvancedSearchScreen extends Component {


    constructor(props) {
        super(props);

        console.log(props.DataSplashScreen);
        container = this;

        let resultData = props.DataSplashScreen.resultsSaina ? props.DataSplashScreen.resultsSaina : props.DataSplashScreen.resultsShahrdar

        this.state = {
            // Father: this.props.route.params.Father
            Father: '',
            FirstName: '',
            LastName: '',
            Once: true,

            dataSourcearrayCompany: [],
            textCompany: null,
            // arrayCompany: props.DataSplashScreen.results.cities,
            arrayCompany: [],
            //Company: {id: 0, value: i18n.t('constant.selectCompany')},
            DateTo: "",
            finalDateTo: "",
            selectedDateTo: 0,
            DateFrom: '',
            finalDateFrom: '',
            selectedDateFrom: 0,
            Company: {id: 0, value: null},
            // type:1,
            type: resultData.result.aramestan ? resultData.result.aramestan.typem[0].id : 1,
            indexSelectType: 0,
            dateModal: 0

        }
    }

    hiddenModal() {
        this.setState({
                visibleModal: ''
            },
            () => {
            })
    }


    onShow(data) {
        this.setState({
            visibleModal: data,

        });
    }

    async setToken(token) {
        await AsyngStorageClass.setToken(token);

    }

    _onRef = (property, view) => {
        this[property] = view
    }
    _scrollIntoView = (ref) => {
        this.scrollToItem(ref)


    }
    scrollToItem = (ref) => {
        this[ref].measureLayout(
            ReactNative.findNodeHandle(this._scroll),
            (x, y) => {
                this._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
            }
        );
    }

    _focusNextField(nextField) {

        this[nextField].focus()
        this[nextField].measureLayout(
            ReactNative.findNodeHandle(this._scroll),
            (x, y) => {
                this._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
            }
        );
    }

    componentWillReceiveProps(propss) {

        if (propss.results != null && this.state.Once === true) {
            //  this.loadingButton.showLoading(false);
            this.setState({
                    Once: false
                },
                () => {
                    if (propss.results.status == true) {

                        global._Father == this.state.Father;
                        global._FirstName == this.state.FirstName;
                        global._LastName == this.state.LastName;
                        global._IdCompany == this.state.Company.id === 0 ? null : this.state.Company.id;


                        this.setToken(propss.results.access_token)

                    }
                    else {
                        alert(propss.results.message)

                    }
                }
            )
        }

    }

    getData() {
        if (this.props.DataSplashScreen.Connection) {
            let {LastName, FirstName, Father, CompanyName, Company, DateFrom, DateTo} = this.state;
            this.setState({
                    Once: true
                },
                () => {
                    let paramss = {
                        //    "token": null,
                        'lang': i18n.locale,
                        "name": FirstName.trim(),
                        "family": LastName.trim(),
                        "Father": Father.trim(),
                        "company_id": Company.id == 0 ? null : Company.id,
                        "DateFrom": DateFrom.trim(),
                        "DateFrom_confirmation": DateTo.trim(),
                    }

                    this.props.callService(
                        typeExport.urlGetGraveyardScreen,
                        paramss,
                        // `?Father=${Father}&name=${FirstName}&name=${FirstName}&token_fb=${this.props.DataSplashScreen.token_fb}&lang=${i18n.locale}`,
                        typeExport.TypegetDataGraveyardScreen,
                        "POST"
                    );
                }
            )

        } else
            this.props.callServiceError("offline")


    }

    checkInput() {
        let {finalDateTo, finalDateFrom, LastName, FirstName, Father, type} = this.state;

        if (!(Tools.CheckValue(LastName) === null || LastName.trim().length == 0)) {
            let itemParams = {
                searchall: null,
                page: 1,
                todate: finalDateTo,
                fromdate: finalDateFrom,
                fathername: Father,
                name: FirstName,
                family: LastName,
                type: type,
            }
            NavigationService.navigateParams("ListDeadScreen", {itemParams})


        } else {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkLastName'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )

        }


    }

    getListCompany(showModal) {

        axios(
            {
                url: typeExport.baseUrl + "/api/companyList?" + `lang=${i18n.locale}`,
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then(response => {

            if (response.status) {
                //  global.ListMessageUnRead=response.data.unread_notifies
                global.ListCompany = response.data.companies;


                this.setState({
                        dataSourcearrayCompany: response.data.companies,
                        textCompany: null,
                        // arrayCompany: props.DataSplashScreen.results.cities,
                        arrayCompany: response.data.companies,
                        //Company: {id: 0, value: i18n.t('constant.selectCompany')},
                        Company: {id: 0, value: null},
                        isLoading: false
                    },
                    () => {
                        showModal ? this.onShow('Company') : null
                    })
            }

            else
                this.setState({
                        isLoading: false
                    },
                    () => {
                        HMAlert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                },
                            ],
                            {cancelable: true}
                        )
                    })
        }).catch((e) => {
            this.setState({
                    isLoading: false
                },
                () => {
                    HMAlert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                }
                            },
                        ],
                        {cancelable: true}
                    )
                })
        })
    }

    async componentDidMount() {
        //this.props.callServiceRefresh();
        // this.getListCompany()
        //  await AsyncStorage.removeItem(typeExport.TOKEN);
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    // goBack() {
    //
    //     this.props.navigation.pop();
    //
    //     // switch (this.props.route.params.type_login) {
    //     //
    //     //     case "fav":
    //     //         this.props.navigation.navigate("MainScreen");
    //     //         break;
    //     //
    //     // }
    //
    // }
    SearchFilterFunction(data, name, text) {
        let dataSource = "dataSource" + data

        let newData = this.state[data].filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })

        if (newData.length == 0 && this.state[data] && this.state[data].length > 0) {
            newData.push(
                ((this.state[data][0]).name ? {
                    name: i18n.t('constant.Others'),
                    id: -2
                } : {sleep_number: i18n.t('constant.Others'), id: -2})
            )
        }

        /*   if(newData.length===0){
                 this.state[data].findIndex(obj => obj.id === action.id);
               const textData = text.toUpperCase()
               newData = itemData.indexOf(i18n.locale=='en'?'others') > -1

           }*/
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

    render() {
        let {item, data} = this.props.route.params
        // let data = "جستجوی پیشرفته"

        //  let date= container.state[`finalDate`+container.state.NameDate]?moment(container.state[`finalDate`+container.state.NameDate], 'YYYY/MM/DD').locale('en').format('YYYY/MM/DD'):null
        let date = container.state[`finalDate` + container.state.NameDate] ? moment(container.state[`finalDate` + container.state.NameDate], 'jYYYY/jM/jD').format('YYYY-MM-DD') : null
        let resultData = this.props.DataSplashScreen.resultsSaina ? this.props.DataSplashScreen.resultsSaina : this.props.DataSplashScreen.resultsShahrdar;
        return (
            <View style={{position: 'relative', flex: 1}}>


                {/* <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView
                        //ref={scroll => this._onRef('_scroll', scroll)}
                        style={{flex: 1,}} behavior={"padding"}
                        enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('constant.Register')}
                            text={(item && item.name ? item.name : (item && item.title ? item.title : ''))}
                            back
                            //  text={i18n.t('constant.Information')}
                            menu
                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        <View style={{flex: 1,}}>


                            <ScrollView
                                keyboardShouldPersistTaps="handled"
                                ref={scroll => this._onRef('_scroll', scroll)}
                                style={{
                                    //backgroundColor: "white"
                                }}>


                                {/*<View style={{*/}
                                {/*width: '100%',*/}
                                {/*flexDirection: 'row',*/}
                                {/*backgroundColor: Colors.light,*/}
                                {/*padding: moderateScale(10),*/}
                                {/*alignItems: "center",*/}
                                {/*justifyContent: "center",*/}
                                {/*marginBottom: moderateScale(16),*/}
                                {/*}}>*/}
                                {/*<HMTextView text={i18n.t('constant.descRegister')} type="bold" style={{*/}
                                {/*alignSelf: "center",*/}
                                {/*color: Colors.colorDark,*/}
                                {/*fontSize: moderateScale(13),*/}

                                {/*}}/>*/}
                                {/*</View>*/}
                                {/*<HMItemSelectBox*/}
                                {/*//   text={this.state.Company.value === null ? i18n.t('constant.selectCompany') : this.state.Company.value}*/}
                                {/*text={this.state.Company.value === null ? "انتخاب نشده" : this.state.Company.value}*/}

                                {/*onShow={() => {*/}

                                {/*if (this.state.dataSourcearrayCompany.length == 0 && global.ListCompany.length == 0)*/}
                                {/*this.setState({*/}
                                {/*isLoading: true*/}
                                {/*},*/}
                                {/*() => {*/}
                                {/*this.getListCompany("showModal")*/}
                                {/*})*/}
                                {/*else*/}
                                {/*this.onShow('Company')*/}
                                {/*}}*/}
                                {/*//  title={i18n.t('constant.company')}*/}
                                {/*title={"نوع"}*/}

                                {/*/>*/}
                                <View style={{paddingHorizontal: moderateScale(12)}}>
                                    <FlatList
                                        //   inverted={true}
                                        keyboardShouldPersistTaps="handled"

                                        style={{
                                            height: moderateScale(40),
                                            marginVertical: moderateScale(10),
                                            alignSelf: 'center'
                                        }}
                                        //  data={data.results.all_categories}
                                        //  data={[{id: 1, name: 'متوفی'}, {id: 2, name: 'شعید'}]}
                                        data={resultData.result.aramestan ? resultData.result.aramestan.typem : []}

                                        renderItem={({item, index}) =>

                                            <TouchableOpacity
                                                onPress={() => {

                                                    this.setState({
                                                        indexSelectType: index,
                                                        type: item.id
                                                    })
                                                }
                                                }
                                                style={{
                                                    paddingHorizontal: moderateScale(3),
                                                    backgroundColor: this.state.indexSelectType == index ? Colors.colorSecondPrimary : Colors.gray,
                                                    borderRadius: moderateScale(10),
                                                    marginHorizontal: moderateScale(2),
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >

                                                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                                <HMTextView text={item.name} type={"bold"}
                                                            style={{
                                                                color: Colors.white,
                                                                marginHorizontal: moderateScale(6),
                                                                fontSize: moderateScale(13),
                                                                textAlign: 'center',
                                                                paddingHorizontal: moderateScale(4)
                                                            }}/>


                                            </TouchableOpacity>
                                        }
                                        horizontal={true}
                                        showsHorizontalScrollIndicator={false}
                                        keyExtractor={(item, index) => index.toString()}
                                        //inverted={true}
                                    />
                                    <HMTextInput value={this.state.FirstName}
                                        //keyboardType="numeric"
                                                 onChangeText={text => {
                                                     this.setState({FirstName: text})
                                                 }}
                                        //containerStyle={{backgroundColor:Colors.white}}
                                                 icon={"ios-contact"}
                                        //  autoFocus
                                                 _width={'84%'}
                                                 placeholder={i18n.t('constant.FirstName')}
                                                 NoShowPlaceholder
                                        //      secureTextEntry={true}
                                        //  requireField
                                                 containerStyle={{width: '90%', alignSelf: 'center',}}
                                                 styleInput={{paddingVertical: moderateScale(6)}}
                                                 style={{
                                                     // marginStart: moderateScale(10),
                                                     fontSize: moderateScale(14),


                                                     //  marginTop: moderateScale(6)
                                                 }} underlineColorAndroid="transparent" maxLength={11}

                                                 _ref={view => this._onRef('ref_FirstName', view)}
                                                 _onFocus={(event) => {
                                                     this._scroll.scrollResponderHandleScroll(event);
                                                 }}
                                                 _onSubmitEditing={() => this._focusNextField('ref_LastName')}

                                    />
                                    <HMTextInput value={this.state.LastName}
                                        //keyboardType="numeric"
                                                 onChangeText={text => {
                                                     this.setState({LastName: text})
                                                 }}
                                        // containerStyle={{backgroundColor:Colors.white}}

                                                 icon={"ios-contacts"}
                                        //  autoFocus
                                                 _width={'84%'}
                                                 placeholder={i18n.t('constant.LastName')}
                                                 NoShowPlaceholder
                                        // secureTextEntry={true}
                                                 requireField
                                                 containerStyle={{
                                                     width: '90%',
                                                     alignSelf: 'center',
                                                     marginVertical: moderateScale(4)
                                                 }}
                                                 styleInput={{paddingVertical: moderateScale(6)}}
                                                 style={{
                                                     // marginStart: moderateScale(10),
                                                     fontSize: moderateScale(14),
                                                     //   marginVertical:moderateScale(10)
                                                     //  marginTop: moderateScale(6)
                                                 }} underlineColorAndroid="transparent" maxLength={11}

                                                 _ref={view => this._onRef('ref_LastName', view)}
                                                 _onFocus={(event) => {
                                                     this._scroll.scrollResponderHandleScroll(event);
                                                 }}
                                                 _onSubmitEditing={() => {
                                                     //this._focusNextField('ref_Father')

                                                 }

                                                 }

                                    />
                                    <HMTextInput value={this.state.Father}

                                        // keyboardType="numeric"
                                                 onChangeText={text => this._changeText(text)}
                                        //autoFocus
                                                 placeholder={i18n.t('constant.Father')}
                                                 NoShowPlaceholder
                                                 _width={'84%'}
                                        // containerStyle={{backgroundColor:Colors.white}}
                                                 editable
                                                 icon={"ios-person"}
                                                 containerStyle={{width: '90%', alignSelf: 'center',}}
                                                 styleInput={{paddingVertical: moderateScale(6)}}
                                                 style={{


                                                     fontSize: moderateScale(14),
                                                     // marginTop: moderateScale(6)
                                                 }}
                                                 underlineColorAndroid="transparent"
                                                 maxLength={11}
                                        //   requireField
                                                 _ref={view => this._onRef('ref_Father', view)}
                                                 _onFocus={(event) => {
                                                     this._scroll.scrollResponderHandleScroll(event);
                                                 }}
                                                 _onSubmitEditing={() => {
                                                     //this._focusNextField('ref_DateFrom')
                                                 }}
                                    />
                                    <View style={{flexDirection: 'row'}}>
                                        <TouchableOpacity
                                            style={{width: '50%', alignSelf: 'center'}}
                                            onPress={() => {

                                                this.setState({NameDate: "From", showDialogDate: true})

                                            }}

                                        >
                                            {/*<Card>*/}
                                            {/*<CardItem style={{*/}
                                            {/*paddingLeft: 0,*/}
                                            {/*paddingRight: 0,*/}
                                            {/*paddingTop: 0,*/}
                                            {/*paddingBottom: 0,*/}

                                            {/*}}>*/}
                                            <View
                                                style={{flex: 1, flexDirection: 'row'}}>

                                                <View
                                                    style={{
                                                        height: moderateScale(40),
                                                        width: moderateScale(40),
                                                        //   flex: .31,
                                                        flexDirection: 'row',

                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        //backgroundColor: "#ee6e6c"
                                                    }}>

                                                    <View style={{flex: 1}}>
                                                        <TouchableOpacity style={{
                                                            height: moderateScale(24),
                                                            width: moderateScale(24),
                                                            borderWidth: moderateScale(.7),
                                                            borderColor: Colors.gray,
                                                            borderRadius: moderateScale(12),
                                                            alignSelf: 'center',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                                          onPress={() => {
                                                                              // this.handleDateChange()
                                                                              this.onPressCancelDate("From")
                                                                          }
                                                                          }
                                                        >
                                                            <Image
                                                                source={this.state.selectedDateFrom === 1 ? (PathFile.image.Check) : null}
                                                                style={{
                                                                    alignSelf: 'center',
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    tintColor: Colors.green

                                                                }}/>
                                                        </TouchableOpacity>
                                                    </View>

                                                </View>
                                                <View style={{
                                                    flex: .69,
                                                }}>
                                                    <HMTextView type={"bold"}
                                                                text={" تاریخ وفات از ( اختیاری )"}
                                                                style={{
                                                                    textAlign: "right",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(12),
                                                                    marginTop: moderateScale(2)

                                                                    //marginEnd: moderateScale(10)
                                                                }}/>
                                                    <HMTextView type={"bold"}
                                                                text={"تاریخ : " + (this.state.finalDateFrom ? this.state.finalDateFrom : " انتخاب نشده ")}
                                                                style={{
                                                                    margin: moderateScale(2),
                                                                    textAlign: "right",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(10),

                                                                    //marginEnd: moderateScale(10)
                                                                }}/>

                                                </View>

                                            </View>
                                            {/*</CardItem>*/}
                                            {/*</Card>*/}
                                        </TouchableOpacity>
                                        <TouchableOpacity

                                            style={{width: '50%', alignSelf: 'center'}}
                                            onPress={() => {

                                                this.setState({NameDate: "To", showDialogDate: true})

                                            }}

                                        >
                                            {/*<Card>*/}
                                            {/*<CardItem style={{*/}
                                            {/*paddingLeft: 0,*/}
                                            {/*paddingRight: 0,*/}
                                            {/*paddingTop: 0,*/}
                                            {/*paddingBottom: 0,*/}

                                            {/*}}>*/}
                                            <View
                                                style={{flex: 1, flexDirection: 'row'}}>
                                                <View
                                                    style={{
                                                        height: moderateScale(40),
                                                        width: moderateScale(40),
                                                        // flex: .31,
                                                        flexDirection: 'row',

                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                    }}>

                                                    <View style={{flex: 1}}>
                                                        <TouchableOpacity style={{
                                                            height: moderateScale(24),
                                                            width: moderateScale(24),
                                                            borderWidth: moderateScale(.7),
                                                            borderColor: Colors.gray,
                                                            borderRadius: moderateScale(12),
                                                            alignSelf: 'center',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                                          onPress={() => {
                                                                              // this.handleDateChange()
                                                                              this.onPressCancelDate("To")
                                                                          }
                                                                          }
                                                        >
                                                            <Image
                                                                source={this.state.selectedDateTo === 1 ? (Platform.OS === "web" ? {uri: typeExport._baseUrlImageAssets + "check-mark.png"} : PathFile.image.Check) : null}
                                                                style={{
                                                                    alignSelf: 'center',
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    tintColor: Colors.green

                                                                }}/>
                                                        </TouchableOpacity>
                                                    </View>

                                                </View>
                                                <View style={{
                                                    flex: 1,
                                                }}>
                                                    <HMTextView type={"bold"}
                                                                text={" تاریخ وفات تا ( اختیاری )"}
                                                                style={{
                                                                    textAlign: "right",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(12),
                                                                    marginTop: moderateScale(2)

                                                                    //marginEnd: moderateScale(10)
                                                                }}/>
                                                    <HMTextView type={"bold"}
                                                                text={"تاریخ : " + (this.state.finalDateTo ? this.state.finalDateTo : " انتخاب نشده ")}
                                                                style={{
                                                                    margin: moderateScale(2),
                                                                    textAlign: "right",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(10),

                                                                    //marginEnd: moderateScale(10)
                                                                }}/>

                                                </View>

                                            </View>
                                            {/*</CardItem>*/}
                                            {/*</Card>*/}
                                        </TouchableOpacity>
                                    </View>
                                </View>

                            </ScrollView>

                            <View style={{position: 'absolute', bottom: 0, width: '100%'}}>
                                <TouchableOpacity style={{
                                    backgroundColor: Colors.colorPrimary,
                                    width: "98%",
                                    height: moderateScale(40),
                                    marginTop: moderateScale(8),
                                    marginBottom: moderateScale(8),
                                    alignSelf: 'center',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // marginTop: moderateScale(14),
                                    borderRadius: moderateScale(6)
                                    // borderRadius:moderateScale(2)
                                }}
                                                  onPress={() => this.checkInput()}
                                >
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                        <HMTextView
                                            type={"bold"}
                                            //  text={i18n.t('constant.Save')}
                                            text={i18n.t('constant.Search')}
                                            style={{
                                                color: "white",
                                                fontSize: moderateScale(16),
                                                // marginEnd: moderateScale(10)
                                            }}/>

                                    </View>
                                </TouchableOpacity>

                                {
                                    Platform.OS !== 'android' ?
                                        <TouchableOpacity
                                            style={{
                                                backgroundColor: Colors.colorPrimary,
                                                width: "98%",
                                                height: moderateScale(40),
                                                marginBottom: moderateScale(6),
                                                alignSelf: 'center',
                                                alignItems: "center",
                                                justifyContent: "center",
                                                // marginTop: moderateScale(14),
                                                borderRadius: moderateScale(6)
                                                // borderRadius:moderateScale(2)
                                            }}
                                            onPress={async () => {
                                                let {finalDateTo, finalDateFrom, LastName, FirstName, Father, type} = this.state;

                                                try {
                                                    //More Locales will be available upon release.
                                                    var spokenText = await SpeechAndroid.startSpeech("نام و نام خانوادگی ...", SpeechAndroid.PERSIAN);
                                                    this.setState({textInputSearch: spokenText}
                                                        ,
                                                        () => {
                                                            NavigationService.navigateParams('ListDeadScreen', {

                                                                itemParams: {
                                                                    title: i18n.t('constant.Search'),
                                                                    type: type,
                                                                    searchall: spokenText,
                                                                }
                                                            })
                                                        }
                                                    );
                                                    // ToastAndroid.show(spokenText, ToastAndroid.LONG);
                                                } catch (error) {
                                                    switch (error) {
                                                        case SpeechAndroid.E_VOICE_CANCELLED:
                                                            ToastAndroid.show("Voice Recognizer cancelled", ToastAndroid.LONG);
                                                            break;
                                                        case SpeechAndroid.E_NO_MATCH:
                                                            ToastAndroid.show("No match for what you said", ToastAndroid.LONG);
                                                            break;
                                                        case SpeechAndroid.E_SERVER_ERROR:
                                                            ToastAndroid.show("Google Server Error", ToastAndroid.LONG);
                                                            break;
                                                    }

                                                }
                                            }}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    //  text={i18n.t('constant.Save')}
                                                    text={'جستجو صوتی'}
                                                    style={{
                                                        color: "white",
                                                        fontSize: moderateScale(16),
                                                        // marginEnd: moderateScale(10)
                                                    }}/>

                                            </View>
                                        </TouchableOpacity>
                                        :
                                        null
                                }
                            </View>
                            {/*<HMModal*/}
                            {/*visibleModal={this.state.visibleModal === 'Company'}*/}
                            {/*hiddenModal={() => this.hiddenModal()}*/}
                            {/*textInput={this.state.textCompany}*/}
                            {/*SearchFilterFunction={textCompany => this.SearchFilterFunction("arrayCompany", "textCompany", textCompany,)}*/}
                            {/*//textInput={this.state.Father}*/}
                            {/*dataSource={this.state.dataSourcearrayCompany.length > 0 ? this.state.dataSourcearrayCompany : global.ListCompany}*/}
                            {/*// onChange={() => this.onChangeCompany(index, item)}*/}
                            {/*onChangeItem={this.onChangeCompany}*/}
                            {/*/>*/}

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        onPress={() => this.checkInput()}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading || this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }

                        </View>
                        {
                            this.state.showDialogDate ?
                                <TouchableHighlight
                                    onPress={() => {
                                        this.onPressBackDate()
                                    }}

                                    style={{
                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        zIndex: 9900,
                                        backgroundColor: 'rgba(0,0,0,0.4)',
                                        justifyContent: 'flex-end',
                                        position: 'absolute',
                                        flex: 1,
                                    }}>

                                    <View style={{backgroundColor: "#fdfdfd"}}>


                                        <DatePicker
                                            ref={view => this._onRef('ref_DatePicker', view)}
                                            //   defDateString={container.state[`finalDate`+container.state.NameDate]?container.state[`finalDate`+container.state.NameDate]:null}
                                            defDateString={date}
                                            // defDate={null}
                                            showTitleDate={true}
                                            dateBoxStyle={{height: moderateScale(50)}}
                                            onChangeDate={(date) => {
                                                container.onDayPress(date)
                                            }}
                                            // onChangeDate={(date)=>{
                                            //
                                            // }}
                                        />
                                        {/*<Calendar*/}
                                        {/*onDayPress={this.onDayPress}*/}
                                        {/*jalali={true}*/}
                                        {/*firstDay={6}*/}
                                        {/*style={styles.calendar}*/}
                                        {/*hideExtraDays*/}
                                        {/*markedDates={{*/}
                                        {/*[this.state.Date]: {*/}
                                        {/*selected: true,*/}
                                        {/*disableTouchEvent: true,*/}
                                        {/*selectedDotColor: 'orange'*/}
                                        {/*}*/}
                                        {/*}}*/}
                                        {/*/>*/}
                                        {/*<Agenda*/}
                                        {/*jalali={true}*/}
                                        {/*firstDay={6}*/}
                                        {/*style={styles.calendar}*/}
                                        {/*hideExtraDays*/}
                                        {/*markedDates={{*/}
                                        {/*[this.state.Date]: {*/}
                                        {/*selected: true,*/}
                                        {/*disableTouchEvent: true,*/}
                                        {/*selectedDotColor: 'orange'*/}
                                        {/*}*/}
                                        {/*}}*/}
                                        {/*/>*/}
                                        <View style={{
                                            flexDirection: 'row',
                                            marginVertical: moderateScale(10),
                                            justifyContent: 'space-between',
                                            paddingHorizontal: moderateScale(4)
                                        }}>
                                            <TouchableOpacity style={{
                                                backgroundColor: Colors.green,
                                                width: "32%",
                                                height: moderateScale(40),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                // borderRadius:moderateScale(2)
                                            }}
                                                              onPress={() => {
                                                                  this.onPressOkDate()
                                                              }}

                                            >
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    <HMTextView type={"bold"} text={"تایید"} style={{
                                                        color: "white",
                                                        fontSize: moderateScale(16),
                                                        // marginEnd: moderateScale(10)
                                                    }}/>

                                                </View>
                                            </TouchableOpacity>
                                            <TouchableOpacity style={{
                                                backgroundColor: Colors.red,
                                                width: "32%",
                                                height: moderateScale(40),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                // borderRadius:moderateScale(2)
                                            }}
                                                              onPress={() => {
                                                                  this.onPressCancelDate(this.state.NameDate)
                                                              }}

                                            >
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    <HMTextView type={"bold"} text={"لغو"} style={{
                                                        color: "white",
                                                        fontSize: moderateScale(16),
                                                        //marginEnd: moderateScale(10)
                                                    }}/>

                                                </View>
                                            </TouchableOpacity>

                                            <TouchableOpacity style={{
                                                backgroundColor: Colors.colorDark,
                                                width: "32%",
                                                height: moderateScale(40),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                // borderRadius:moderateScale(2)
                                            }}
                                                              onPress={() => {
                                                                  this.onPressBackDate()
                                                              }}

                                            >
                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    <HMTextView type={"bold"} text={i18n.t('constant.Back')} style={{
                                                        color: "white",
                                                        fontSize: moderateScale(16),
                                                        // marginEnd: moderateScale(10)
                                                    }}/>

                                                </View>
                                            </TouchableOpacity>
                                        </View>
                                    </View>


                                </TouchableHighlight>
                                :
                                null
                        }


                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }

    onChangeCompany(index, data) {

        container.setState({
            Company: {value: data.name, id: data.id},

            visibleModal: ''
        })
    }

    _changeText(text) {
        container.setState({Father: text});
    }

    onDayPress(day) {
        container.setState({
                ["Date" + container.state.NameDate]: day.format('jYYYY/jM/jD'),

            }
            , () => {
                //   alert(day.dateString)
                // alert( moment(day.dateString, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'))

            }
        );
    }

    onPressOkDate() {
        // if (container.state["Date" + container.state.NameDate]) {
        container.setState({
                // NameDate: data,
                //  finalDate: moment(container.state.Date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'),
                //  selectedDate: 1
                showDialogDate: null,
                [`finalDate${container.state.NameDate}`]: container.state["Date" + container.state.NameDate] ? container.state["Date" + container.state.NameDate] : moment().format("jYYYY/jMM/jDD"),
                ["selectedDate" + container.state.NameDate]: 1
            },
            () => {
            });
        // }
        // else {
        //     HMAlert(
        //         i18n.t('constant.message'),
        //         "تاریخی را انتخاب نگرده اید!!!",
        //         [
        //             // {text: 'Ask me later', onPress: () => {}},
        //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
        //             {text: 'خب', onPress: () => {}},
        //         ],
        //         {cancelable: true}
        //     )
        // }

    }

    onPressCancelDate(name) {
        if (container.state.showDialogDate === null && container.state[`finalDate` + name]) {
            container.setState({

                    showDialogDate: null,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        }
        else if (container.state.showDialogDate === null && !container.state[`finalDate` + name]) {
            container.setState({

                    showDialogDate: true,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        }
        else if (container.state.showDialogDate !== null && container.state[`finalDate` + name]) {
            container.setState({

                    showDialogDate: null,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        } else
            container.setState({
                    showDialogDate: true,
                    // selectedDate: 0,
                    // Date: 0,
                    // finalDate: 0
                    NameDate: name,
                    ["selectedDate" + name]: 0,
                    ["Date" + name]: 0,
                    ["finalDate" + name]: 0
                },
                () => {
                });
    }

    onPressBackDate() {
        container.setState({
            showDialogDate: null
        })
    }

}


const styles = StyleSheet.create({
    containerEmpty: {
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: Colors.backgroundColor,
    },
    container: {
        flex: 1,
        justifyContent: "space-between",
        backgroundColor: Colors.backgroundColor,
    },
    // container: {
    //     flex: 1,
    //     backgroundColor: Colors.backgroundColor
    // },
    containerHasLoading: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.backgroundColor
    },
    tabTextStyle: {
        fontFamily: typeExport.regularFontName,
        padding: verticalScale(2),

    },
    tabsContainerStyle: {
        marginVertical: moderateScale(6),
        marginHorizontal: moderateScale(10),

    },
    activeTabTextStyle: {
        fontFamily: Platform.OS === "ios" ? typeExport.regularFontName : typeExport.boldFontName,
        fontWeight: Platform.OS === "ios" ? "900" : null,
    },
    calendar: {
        borderTopWidth: 1,
        paddingTop: 5,
        borderBottomWidth: 1,
        borderColor: '#eee',
        // height: moderateScale(350)
    },
});

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchScreen);
